export const ActionTypes = {
    SET_CRM_LOOKUP_DATA: 'SET_CRM_LOOKUP_DATA',
    SET_CRM_PRODUCT_LIST: 'SET_CRM_PRODUCT_LIST',
    SET_CRM_ACCOUNT_PLAN: 'SET_CRM_ACCOUNT_PLAN',
    UPDATE_CENTER_NOTES: 'UPDATE_CENTER_NOTES',
    SET_PRODUCT_IS_ACTIVE: 'SET_PRODUCT_IS_ACTIVE'
}